import React from 'react';
import styled from 'styled-components';
import SEO from '../../components/SEO';
import Scroll from '../../components/Scroll';
import HeroSection from '../../components/HeroSection';
import FeaturedProducts from '../../components/FeaturedProducts';
import Model from '../../components/Model';
import Features from '../../components/Features';
import NewArrivals from '../../components/NewArrivals';

const Home = () => {
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Nike 3D Store - Premium Athletic Footwear & Sportswear",
    "description": "Discover Nike's premium collection with revolutionary 3D product showcase. Shop Air Max, Jordan, React and more with authentic guarantee.",
    "url": "https://nike3d.com/",
    "mainEntity": {
      "@type": "ItemList",
      "name": "Featured Nike Products",
      "description": "Premium Nike athletic footwear and sportswear collection",
      "numberOfItems": 10,
      "itemListElement": [
        {
          "@type": "Product",
          "position": 1,
          "name": "Nike Air Max 270",
          "category": "Athletic Shoes",
          "brand": "Nike"
        },
        {
          "@type": "Product", 
          "position": 2,
          "name": "Nike Air Force 1",
          "category": "Athletic Shoes",
          "brand": "Nike"
        },
        {
          "@type": "Product",
          "position": 3, 
          "name": "Nike React Infinity",
          "category": "Running Shoes",
          "brand": "Nike"
        }
      ]
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://nike3d.com/"
        }
      ]
    }
  };

  return (
    <HomeContainer>
      <SEO
        title="Nike 3D Store - Premium Athletic Footwear & Sportswear | Just Do It"
        description="Discover Nike's premium collection of athletic footwear, sportswear, and accessories. Experience our revolutionary 3D product showcase featuring Air Max, Jordan, React, and more. Shop the latest Nike innovations with fast shipping and authentic guarantee."
        keywords="Nike, athletic shoes, sportswear, Air Max, Jordan, React, running shoes, basketball shoes, lifestyle sneakers, Nike store, athletic apparel, sports gear, Just Do It, 3D showcase"
        canonicalUrl="https://nike3d.com/"
        structuredData={homeStructuredData}
      />
      <Scroll />
      <HeroSection />
      <FeaturedProducts />
      <Model />
      <Features />
      <NewArrivals />
    </HomeContainer>
  );
};

export default Home;

const HomeContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;
